import React from 'react'
import {Flex, Text, Img, useStyleConfig, Link as ChakraLink} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import {CutleryIcon, ChronoIcon} from '../../icons'
import {FormattedMessage} from 'react-intl'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import useCurrentHost from '../../../hooks/use-current-host'

export const RecipeTile = ({
    title,
    recipeTitle,
    description,
    uid,
    imageData,
    difficulty,
    timeToComplete,
    gridView,
    listPage = 'recipes',
}) => {
    const styles = useStyleConfig('RecipeTile')
    const {buildUrl} = useMultiSite()
    const {getHost} = useCurrentHost()

    const damImage = imageData
    const recipePath =
        uid && title ? `/r/${listPage}/${title.replace(/[\s']+/g, '-').toLowerCase()}/${uid}` : ''
    const recipeUrl = recipePath ? `${getHost()}${buildUrl(recipePath)}` : '#'

    return (
        <Flex {...styles?.recipeContainer}>
            <ChakraLink
                href={recipeUrl}
                {...styles?.imageContainer}
                _hover={{textDecoration: 'none'}}
                display="flex"
            >
                <Img {...styles?.imageObject} src={damImage} alt={recipeTitle} />
            </ChakraLink>
            <Flex {...styles?.textsContainer}>
                <ChakraLink href={recipeUrl} _hover={{textDecoration: 'none'}}>
                    <Text
                        as="h2"
                        {...styles?.titleText}
                        sx={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                        }}
                    >
                        {recipeTitle}
                    </Text>
                </ChakraLink>
                <Text {...styles?.descriptionText}>{description}</Text>
                <Flex {...styles?.extraContainer} flexDir={gridView ? 'column' : 'row'}>
                    {difficulty && (
                        <Flex {...styles?.infoContainer}>
                            <CutleryIcon {...styles?.iconConfig} />{' '}
                            <Text {...styles?.infoText}>{difficulty}</Text>
                        </Flex>
                    )}
                    {timeToComplete && (
                        <Flex {...styles?.infoContainer}>
                            <ChronoIcon {...styles?.iconConfig} />{' '}
                            <Text {...styles?.infoText}>
                                {timeToComplete}{' '}
                                <FormattedMessage
                                    id="recipes.listing_page.recipe_tile.time_to_complete_time.text"
                                    defaultMessage="min"
                                />
                            </Text>
                        </Flex>
                    )}
                </Flex>
            </Flex>
        </Flex>
    )
}

RecipeTile.propTypes = {
    title: PropTypes.string,
    recipeTitle: PropTypes.string,
    description: PropTypes.string,
    uid: PropTypes.string,
    imageData: PropTypes.string,
    difficulty: PropTypes.string,
    timeToComplete: PropTypes.string,
    gridView: PropTypes.bool,
    listPage: PropTypes.string,
}
